import { request } from '@umijs/max';
import { LoginParams, LoginResultData, MerchantAuthAccount } from '../MerchantTypings';

export namespace MerchantPassport {
  /**
   * @summary 登录
   * @secure
   */
  export const login = async (data: LoginParams, params: { [key: string]: any } = {}) => {
    return request<LoginResultData>(`/merchant/passport/login`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 注销登录
   * @secure
   */
  export const logout = async (params: { [key: string]: any } = {}) => {
    return request<boolean>(`/merchant/passport/logout`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取登录信息
   * @secure
   */
  export const auth = async (params: { [key: string]: any } = {}) => {
    return request<MerchantAuthAccount>(`/merchant/passport/auth`, {
      method: 'GET',
      ...params,
    });
  };
}

export default MerchantPassport;

export const login = MerchantPassport.login;
export const logout = MerchantPassport.logout;
export const auth = MerchantPassport.auth;
